// extracted by mini-css-extract-plugin
export default {"root":"xwIUu","hasBottomNavigation":"FE625"};